<template>
    <div id="TalentResponseForm" class="mb-8 space-y-6" :class="{ 'sm:space-y-10': minified }">
        <div class="flex flex-col gap-3 pt-3">
            <CFormGroup
                v-if="moreAboutTalent.future"
                description="Čomu sa chceš o 5 rokov profesne venovať a prečo? Aké zručnosti chceš nadobudnúť?"
                label='Čím chceš byť, keď "vyrastieš"?'
            >
                <CCardBox>{{ moreAboutTalent.future }}</CCardBox>
            </CFormGroup>

            <CFormGroup
                v-if="moreAboutTalent.succeed"
                description="Popíš situáciu, kedy ťa naposledy zaplavila hrdosť na tvoj postup pri riešení problému."
                label='"Toto sa mi fakt podarilo"'
            >
                <CCardBox>{{ moreAboutTalent.succeed }}</CCardBox>
            </CFormGroup>

            <CFormGroup
                v-if="moreAboutTalent.believe"
                description="Ako vyhodnocuješ hodnovernosť informácií, ktoré sa k tebe dostanú."
                label='"Tomuto mám veriť?"'
            >
                <CCardBox>{{ moreAboutTalent.believe }}</CCardBox>
            </CFormGroup>

            <CFormGroup
                v-if="moreAboutTalent.failure"
                description="Ak sa to stalo aj tebe, čo si sa pri tom naučil/a?"
                label='"Aaaach jaj, toto sa mi fakt nepodarilo!"'
            >
                <CCardBox>{{ moreAboutTalent.failure }}</CCardBox>
            </CFormGroup>

            <CFormGroup
                v-if="moreAboutTalent.end"
                class="!mb-0"
                description="Ktoré úlohy dávaš na koniec svojho zoznamu?"
                label='"Keď už musím, tak to spravím!"'
            >
                <CCardBox>{{ moreAboutTalent.end }}</CCardBox>
            </CFormGroup>
        </div>
    </div>
</template>

<script setup lang="ts">
import CCardBox from '@/components/ui/CCardBox.vue'
import CFormGroup from '@/components/ui/CFormGroup.vue'

interface Props {
    moreAboutTalent: {
        future?: string;
        succeed?: string;
        believe?: string;
        failure?: string;
        end?: string;
    };
    minified?: boolean;
    preview?: boolean;
}

defineProps<Props>()
</script>